// extracted by mini-css-extract-plugin
export default {"uploadStatusContainer":"uploadStatus_uploadStatusContainer__eygTa","lastFileUploadInfo":"uploadStatus_lastFileUploadInfo__ULvYZ"};